import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
// language list
import { locale as ptBrLang } from './core/_config/i18n/pt-br';
import { locale as enLang } from './core/_config/i18n/en';
import { locale as esLang } from './core/_config/i18n/es';

// import { SignalRService } from '../app/core/_config/signal-r.service';

import { OAuthService } from 'angular-oauth2-oidc';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AppConfig } from './core/_config/app.config';
import { AuthServiceCustom } from './core/auth/authServiceCustom';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'body[kt-root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
    // Public properties
    title = 'Metronic';
    loader: boolean = false;
    emailUser: string = '';
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    private API_URL = environment.API_URL;
    /**
     * Component constructor
     *
     * @param translationService: TranslationService
     * @param router: Router
     * @param layoutConfigService: LayoutConfigService
     * @param splashScreenService: SplashScreenService
     */
    constructor(
        private translationService: TranslationService,
        private router: Router,
        private layoutConfigService: LayoutConfigService,
        private splashScreenService: SplashScreenService,
        private oauthService: OAuthService,
        private http: HttpClient,
        private config: AppConfig,
        private authServiceCustom: AuthServiceCustom,
    ) {
        // register translations
        this.translationService.loadTranslations(ptBrLang, enLang, esLang);
        this.oauthService.configure(this.config.oauth);
    }

    ngOnInit(): void {
        // enable/disable loader
        this.loader = this.layoutConfigService.getConfig('page-loader.type');

        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // hide splash screen
                this.splashScreenService.hide();

                window.scrollTo(0, 0);

                setTimeout(() => {
                    document.body.classList.add('page-loaded');
                }, 500);
            }
        });

        this.unsubscribe.push(routerSubscription);
        this.oauthService.loadDiscoveryDocumentAndLogin();
        this.emailUser = this.authServiceCustom.userEmail;

        // if (this.emailUser) {

        //   this.signalRService.startConnection(this.emailUser);
        //   this.signalRService.addTransferChartDataListener();
        // }
    }

    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
}
